'use client'

import { useEffect } from 'react'

export const FormHubspot = ({
  region,
  portalId,
  formId,
  className,
}: {
  region: string
  portalId: string
  formId: string
  className?: string
}) => {
  useEffect(() => {
    const script = document.createElement('script')
    script.src = '//js-eu1.hsforms.net/forms/embed/v2.js'
    document.body.appendChild(script)

    script.addEventListener('load', () => {
      if (window.hbspt) {
        window.hbspt.forms.create({
          region,
          portalId,
          formId,
          target: '#formHubspot',
        })
      }
    })
  })

  return <div id="formHubspot" className={className ?? 'formContact'}></div>
}
